function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

function SvgIconCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 350 350",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-1.9444444444444287 -1.9444444444444287) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74.245 90 h -58.49 c -2.366 0 -4.291 -1.925 -4.291 -4.29 V 4.291 C 11.464 1.925 13.389 0 15.755 0 h 47.324 c 0.052 0.003 0.128 0.003 0.193 0.011 l 0 0 c 0.004 0.001 0.005 0.001 0.005 0.001 c 0.002 0 0.003 0 0.005 0 s 0.004 0 0.005 0 c 0 0 0.002 0.001 0.004 0 c 0.002 0.001 0.003 0 0.005 0.001 c 0 0 0 0 0.001 0 c 0.038 0.005 0.075 0.012 0.113 0.02 c 0.259 0.057 0.502 0.184 0.703 0.374 l 0 0 c 0.001 0.001 0.002 0.002 0.003 0.003 c 0.001 0.001 0.002 0.002 0.003 0.003 l 13.963 13.444 c 0.001 0.001 0.002 0.001 0.003 0.002 c 0 0.001 0.003 0.001 0.002 0.002 c 0.004 0.001 0.001 0.001 0.003 0.002 c 0 0 0.005 -0.003 0.002 0.002 c 0.001 0.001 -0.004 0.001 0.003 0.002 c 0 0 0.001 0.001 0.001 0.001 l 0.001 0 c 0.193 0.192 0.326 0.427 0.392 0.68 v 0 c 0.001 0.001 0.001 0.002 0.001 0.004 c 0.003 0 0 0.002 0.001 0.003 v 0 c 0.011 0.041 0.019 0.081 0.026 0.123 l 0 0 c 0 0.001 0.001 0.002 0.001 0.003 v 0 c 0 0.002 0 0.002 0 0.003 c 0 0 0.001 0.001 0.001 0.001 c 0.013 0.082 0.019 0.165 0.018 0.248 V 85.71 C 78.536 88.075 76.611 90 74.245 90 z M 15.755 2.967 c -0.73 0 -1.324 0.594 -1.324 1.324 V 85.71 c 0 0.729 0.594 1.323 1.324 1.323 h 58.49 c 0.73 0 1.324 -0.594 1.324 -1.323 V 16.411 h -9.673 c -2.365 0 -4.29 -1.925 -4.29 -4.291 V 2.967 H 15.755 z M 64.573 4.971 v 7.149 c 0 0.73 0.594 1.324 1.323 1.324 h 7.477 L 64.573 4.971 z M 56.107 85.884 c -0.038 0 -0.075 -0.001 -0.113 -0.004 c -0.523 -0.041 -0.985 -0.354 -1.218 -0.824 l -1.297 -2.63 l -2.914 -0.319 c -0.522 -0.057 -0.974 -0.385 -1.19 -0.862 c -0.216 -0.477 -0.165 -1.033 0.136 -1.463 l 4.638 -6.625 c -1.636 -1.727 -2.552 -4 -2.552 -6.416 c 0 -5.162 4.2 -9.362 9.363 -9.362 s 9.362 4.199 9.362 9.362 c 0 2.417 -0.916 4.689 -2.552 6.416 l 4.639 6.625 c 0.301 0.43 0.353 0.986 0.136 1.463 c -0.216 0.477 -0.668 0.806 -1.19 0.862 l -2.915 0.319 l -1.296 2.63 c -0.232 0.47 -0.694 0.783 -1.218 0.824 c -0.519 0.041 -1.028 -0.2 -1.328 -0.629 l -3.638 -5.196 l -3.638 5.196 C 57.044 85.649 56.589 85.884 56.107 85.884 z M 53.379 79.43 l 1.232 0.135 c 0.504 0.055 0.945 0.364 1.17 0.819 l 0.549 1.113 l 3.416 -4.879 c 0.554 -0.792 1.876 -0.792 2.43 0 l 3.416 4.878 l 0.548 -1.112 c 0.224 -0.455 0.665 -0.764 1.17 -0.819 l 1.232 -0.135 l -3.947 -5.638 c -0.453 -0.646 -0.321 -1.533 0.3 -2.019 c 1.564 -1.225 2.461 -3.059 2.461 -5.033 c 0 -3.526 -2.869 -6.395 -6.395 -6.395 s -6.396 2.869 -6.396 6.395 c 0 1.974 0.897 3.808 2.461 5.033 c 0.621 0.486 0.753 1.372 0.3 2.019 L 53.379 79.43 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.593 59.369 H 21.924 c -0.82 0 -1.484 -0.664 -1.484 -1.484 c 0 -0.819 0.664 -1.484 1.484 -1.484 h 22.668 c 0.819 0 1.484 0.664 1.484 1.484 C 46.076 58.704 45.412 59.369 44.593 59.369 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.219 49.478 H 21.924 c -0.82 0 -1.484 -0.664 -1.484 -1.484 c 0 -0.819 0.664 -1.484 1.484 -1.484 h 47.294 c 0.819 0 1.484 0.664 1.484 1.484 C 70.702 48.814 70.038 49.478 69.219 49.478 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.219 39.588 H 21.924 c -0.82 0 -1.484 -0.664 -1.484 -1.484 c 0 -0.82 0.664 -1.484 1.484 -1.484 h 47.294 c 0.819 0 1.484 0.664 1.484 1.484 C 70.702 38.924 70.038 39.588 69.219 39.588 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.219 29.698 H 21.924 c -0.82 0 -1.484 -0.664 -1.484 -1.484 s 0.664 -1.484 1.484 -1.484 h 47.294 c 0.819 0 1.484 0.664 1.484 1.484 S 70.038 29.698 69.219 29.698 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.593 19.808 H 21.924 c -0.82 0 -1.484 -0.664 -1.484 -1.484 c 0 -0.82 0.664 -1.484 1.484 -1.484 h 22.668 c 0.819 0 1.484 0.664 1.484 1.484 C 46.076 19.144 45.412 19.808 44.593 19.808 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificate);
export default __webpack_public_path__ + "static/media/iconCertificate.f9cb60e1.svg";
export { ForwardRef as ReactComponent };